import { Link } from "react-router-dom";
import WaveMark from "./WaveMark";

const cols = [
  { title: "About", links: [["Our story", "/about"], ["Our approach", "/process"], ["Why us", "/about"]] },
  { title: "Work", links: [["All projects", "/work"], ["Case studies", "/work"]] },
  { title: "Services", links: [["Websites", "/services"], ["Google Business", "/services"], ["Social Media", "/services"]] },
  { title: "Pricing", links: [["Website packages", "/pricing"], ["Additional services", "/pricing"], ["Aftercare", "/pricing"]] },
  { title: "Process", links: [["How it works", "/process"], ["What to expect", "/process"]] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink-deep text-white">
      <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-12 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3"><WaveMark width={44} /><span className="font-display text-xl font-bold tracking-[0.16em]">WAVE ELEVEN</span></div>
            <p className="mt-3 text-[10px] uppercase tracking-label text-slate-mute">Digital Design Studio</p>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/60">Premium websites and digital services for ambitious businesses across the UK.</p>
            <address className="mt-6 not-italic text-sm leading-7 text-white/70">
              Poole · Dorset · UK<br />
              <a href="mailto:info@waveeleven.co.uk" className="transition-opacity hover:opacity-60">info@waveeleven.co.uk</a>
            </address>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7 md:col-start-6 md:grid-cols-5">
            {cols.map((c) => (
              <div key={c.title}>
                <p className="text-[10px] uppercase tracking-label text-slate-mute">{c.title}</p>
                <ul className="mt-4 space-y-2.5 text-sm text-white/70">
                  {c.links.map(([label, to]) => (
                    <li key={label}><Link to={to} className="transition-opacity hover:opacity-60">{label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-[11px] uppercase tracking-label text-slate-mute md:flex-row">
          <span>© Wave Eleven 2026</span>
          <span className="flex gap-6">
            <Link to="/privacy" className="hover:text-white/80">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white/80">Terms &amp; Conditions</Link>
            <Link to="/cookies" className="hover:text-white/80">Cookies</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
